module.exports = __webpack_public_path__ + "img/English-03.12003732.jpg";